import _ from 'lodash';

// Resolve a link template like `/app/{workspaceKey}/portfolio/projects/{projectId}`
// against a row and the current workspaceKey. Returns null if any placeholder
// resolves to a null/empty value — callers should render plain text in that case.
export function resolveLink(template, row, workspaceKey) {
  if (!template || !workspaceKey) return null;
  let hasNull = false;
  const resolved = template.replace(/\{([^}]+)\}/g, (__, key) => {
    if (key === 'workspaceKey') return workspaceKey;
    const val = _.get(row, key);
    if (val == null || val === '') hasNull = true;
    return val ?? '';
  });
  return hasNull ? null : resolved;
}
